<div class="footer flex">
  <div class="flex-auto flex items-center container">
    <a class="action flex-none"
       color="primary"
       mat-flat-button>
      <span>{{'CIB-OAT - Admin Panel' | translate}}</span>
    </a>
    <div class="font-medium hidden ltr:ml-4 rtl:mr-4 sm:block">
      {{'Copyright © 2024 CIB-OAT - All rights reserved.' | translate}}
    </div>
  </div>
</div>
